 document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger)
  
   let tl = gsap.timeline({
    scrollTrigger: {
        trigger: '#new_hero',
        start: 'top 15%', 
		end: 'bottom bottom',
       
    }
   })
    console.log("animate");
   tl.to(".mian_heading > *",{
    delay:0.1,
    y: 0,              
    opacity: 1,
    duration: 1,
    stagger: 0.25,
    ease: "power2.out",
   });
    tl.to(".shoues_image img",{
    opacity:1,           
    duration: 1,
    ease: "power1.out"
   });

   gsap.to(".shoues_image", {
    y: -200,               
    ease: "none",
    scrollTrigger: {
      trigger: "#new_hero",
      start: "top top",
      end: "bottom top",
      scrub: 1,
      
    }
  });

 const image_grids = document.querySelectorAll(".image_grid, .image_box");

ScrollTrigger.matchMedia({

  // 👇 Mobile view (max-width: 767px)
  "(max-width: 767px)": function () {
    image_grids.forEach((image_grid) => {
      const seimg = image_grid.querySelectorAll("img");

      gsap.to(seimg, {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power2.out",
        stagger: 0.5,
        scrollTrigger: {
          trigger: image_grid,
          start: "-100% 55%",  
          once: true,
         
        },
      });
    });
  },

  // 👇 Desktop view (min-width: 768px)
  "(min-width: 768px)": function () {
    image_grids.forEach((image_grid) => {
      const seimg = image_grid.querySelectorAll("img");

      gsap.to(seimg, {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power2.out",
        stagger: 0.5,
        scrollTrigger: {
          trigger: image_grid,
          start: "-75% top",  
          once: true,
        },
      });
    });
  }

});
  

 });

 